export enum tableDonneeTypes {
    LOADING = "LOADING",
    SELECTED_TABLE_DONNEE = "SELECTED_TABLE_DONNEE",
    GET_TABLE_DONNEE_LIST = "GET_TABLE_DONNEE_LIST",
}
  
export default tableDonneeTypes;